import { render, staticRenderFns } from "./reviewQrcode.vue?vue&type=template&id=e4eb3b64&scoped=true"
import script from "./reviewQrcode.vue?vue&type=script&lang=js"
export * from "./reviewQrcode.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4eb3b64",
  null
  
)

export default component.exports